import { DatePipe } from "@angular/common";

export const isTrue = (v) => {
    return v && (v === true || `${v}`.toLowerCase() === 'true');
}

export const InputPipes = {
    'date': (v, e) => new DatePipe('en-US').transform(v, e),
    default: (v) => v
}

export const formatInput = (value: string, format: string) => {
    try {
        const parts = format.split(':');
        const response = InputPipes[parts.shift() || 'default'](value, parts.shift());
        return response;
    } catch (e) {
        return value;
    }
}
